// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"ebd85617","453":"eca5f793","508":"60d0f869","629":"4115418c","869":"be0b51d0"}[chunkId] + ".chunk.js";
};